import React from 'react';
import { SearchCard } from '../types';
import { BaseResponsiveSearchCard } from '../Base';
import {
  Price,
  GrayUIText,
  Title,
  BlackUIText,
  UnitPriceText,
  GrayPrice,
  BottomContent,
} from '../Base/styles';
import styled from 'styled-components';
import { theme } from '../../../../theme';
import {
  BoxConditionIcon,
  CartIcon,
  MapMarkerIcon,
  TruckIcon,
} from '../../../../assets';
import { Pill } from '../../../basePill';

const Content = styled.div<{ grayPrice?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
  margin: ${({ grayPrice }) =>
    grayPrice
      ? `${theme.spacings[2].rem}`
      : `${theme.spacings[3].rem} ${theme.spacings[2].rem}`};
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledPrice = styled(Price)`
  ${theme.typography.headings[6]['sm-lg']};
`;

const StyledGrayPrice = styled(GrayPrice)`
  margin-bottom: ${theme.spacings[0].rem};
`;

export const WineBuyNowResponsiveSearchCard: React.FC<
  SearchCard<'WineBuyNow'>
> = ({
  title,
  condition,
  location,
  isDelivery,
  grayPrice,
  data,
  type,
  ...props
}) => {
  return (
    <BaseResponsiveSearchCard {...props}>
      <Content grayPrice={grayPrice}>
        <Title>{title}</Title>
        <Pill
          backgroundColor={theme.colors.tints.systemBlue[6]}
          icon={CartIcon}
        >
          Buy Now
        </Pill>
        {grayPrice && <StyledGrayPrice>{grayPrice}</StyledGrayPrice>}
        <Container>
          <div>
            <StyledPrice>{data.perBottlePrice}</StyledPrice>
            <BlackUIText>
              <UnitPriceText>Per {data.unitPricing.unitName}</UnitPriceText>
            </BlackUIText>
          </div>
          <div>
            <StyledPrice>{data.secondaryPrice.price}</StyledPrice>
            <BlackUIText>
              <UnitPriceText>
                Per {data.unitPricing.unitCollectiveNoun}
              </UnitPriceText>
            </BlackUIText>
          </div>
        </Container>
        <BottomContent>
          <GrayUIText>
            <BoxConditionIcon
              width={16}
              fill={theme.colors.neutrals.solidGrays[3]}
            />
            {condition}
          </GrayUIText>
          <GrayUIText>
            {isDelivery ? (
              (condition as string).length < 15 && (
                <>
                  <TruckIcon
                    width={16}
                    fill={theme.colors.neutrals.solidGrays[3]}
                  />
                  Delivery
                </>
              )
            ) : (
              <>
                <MapMarkerIcon
                  width={16}
                  fill={theme.colors.neutrals.solidGrays[3]}
                />
                {location}
              </>
            )}
          </GrayUIText>
        </BottomContent>
      </Content>
    </BaseResponsiveSearchCard>
  );
};
